import { MsalAuthProvider, LoginType } from "react-aad-msal";
import { Configuration, AuthenticationParameters, CacheLocation } from "msal";
import cfg from "./config";

const auth = {
  clientId: cfg.apiClientId,
  authority: cfg.authority,
  validateAuthority: true,
  redirectUri: window.location.origin,
  postLogoutRedirectUri: window.location.origin,
};

const cache = {
  storeAuthStateInCookie: false,
  cacheLocation: "localStorage" as CacheLocation,
};

const system = {
  tokenRenewalOffsetSeconds: 600,
};

const framework = {
  isAngular: false,
};

const config: Configuration = {
  auth,
  cache,
  system,
  framework,
};

const params: AuthenticationParameters = {
  scopes: cfg.graphScopes,
};

const authProvider = new MsalAuthProvider(config, params, {
  loginType: LoginType.Redirect,
});

authProvider.setAuthenticationParameters({
  prompt: "select_account",
  authority: cfg.authority,
});

export { authProvider };
